import React, { useState } from "react";
import { Card } from "react-bootstrap";
import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css";
import pagePropertiesStyles from "./PagePropertiesNew.module.css";
import MoreVert from "../../../../Icons/more_vert.svg";
import AllPaddingActive from "../../../../Icons/allPadding.svg";
import DifferentPaddingInActive from "../../../../Icons/diffPadding.svg";
import AllPaddingInActive from "../../../../Icons/allPaddingInActive.svg";
import DifferentPaddingActive from "../../../../Icons/diffPaddingActive.svg";
import LeftAlignSvg from "./LeftAlignSvg";
import Zoning from "./Zoning";
import ControlSet from "../../../LeftNavigation/ControlSet/ControlSet";
import CollapseCards from "../../../../ReusableComponents/CollapseCard/CollapseCard";
import SelectTemplate from "../../../LeftNavigation/PageTemplate/SelectTemplate";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import {
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@material-ui/core";
import clsx from "clsx";
import ColorPicker from "../../../../ReusableComponents/ColorPicker/ColorPicker";
import { useEffect } from "react";
import ImageUploadBtn from "../../../../ReusableComponents/ImageUploadBtn/ImageUploadBtn";
import CenterAlign from "./CenterAlign";
import RIghtAlign from "./RIghtAlign";
import TopAlign from "./TopAlign";
import CenterVertAlign from "./CenterVertAlign";
import BottonAlign from "./BottonAlign";
import Events from "../../../../ReusableComponents/Events/Events";
import { EventListjson } from "../../../../ReusableComponents/Events/EventList";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useTranslation } from "react-i18next";
import { GetState, GetStateFromData } from "../../../CustomHooks/CustomHooks";
import secureLocalStorage from "react-secure-storage";
import { loadArabicImage } from "../../IFormDesignerLogic";
import secureSessionStorage from "../../../../utils/secureSessionStorage";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
  tooltip: {
    maxWidth: "200px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
  hoverBtnColor : {
    "&:hover" : {
      backgroundColor: "#F8F8F8"
    }
  }
});

export const PagePropertiesNew = ({
  containerId,
  formData,
  selectedControl,
}) => {
  const { t } = useTranslation();
  const [openZoning, setOpenZoning] = useState(false);
  const [openControlSet, setOpenControlSet] = useState(false);
  const {templateLoaded} = GetState("templateLoaded");
  const [templateData, setTemplateData] = useState({
    isOpen: false,
    selectedTemplate: "",
  });
  const [pageProperties, setPageProperties] = useState({
    pageConfiguration: {},
    pageDisplay: {
      type: "",
      fixedWidthHeight: { width: "", height: "" },
      variableWidthHeight: { width: "", height: "" },
    },
    pageBackground: { backgroundColor: "", backgroundImage: "", selected: "" },
    formColors: { "background-color": "", "border-color": "" },
    alignments: {
      formHorizontalAlignment: "",
      horizontalSpacingLeft: "0",
      horizontalSpacingRight: "0",
      formVerticalAlignment: "",
      verticalSpacingTop: "0",
      verticalSpacingBottom: "0",
    },
    imageAppearance: "",
    imagePlacement: { horizontalAlignment: "", verticalAlignment: "" },
    imageResponsiveBehaviour: { scaleImage: "", cropImage: "" },
    Events: {
      EventButton: "",
    },
  });
  const contexts = GetStateFromData(containerId);
  const {
    activeApplication,
    setAllPages,
    formState2,
    setFormState2,
    updateJson,
    showAlertConfirmNotifications,
    microFrontendData,
    appname,
    builderMode,
  } = contexts.contexts;

  var activePage = contexts?.contexts?.activePage;
  var activeSubForm = contexts?.contexts?.activeSubForm;
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;

  const applicationNameObj = {
    applicationName:
      microFrontendData?.processName ||
      microFrontendData?.newApplicationName ||
      microFrontendData?.applicationName ||
      microFrontendData?.processDefId ||
      appname || "",
    formName:
      microFrontendData?.taskId ||
      microFrontendData?.formName ||
      activePage?.formName ||
      activeSubForm?.fragmentName ||
      microFrontendData?.formId ||
      microFrontendData?.formDefId ||
      ""
  };
const currentUrl = window?.location?.href
const imageBaseURL =  currentUrl?.includes("openExtInterface") ? "" :
    builderMode === "application" || activePage || activeSubForm || templateLoaded
        ? `${window.apb_backend_app_context}/idesign/getImage/${applicationNameObj.applicationName}/${templateLoaded ? "%20" : applicationNameObj.formName}/${window?.activeCabinet_formbuilder}/`
        : "";


  const { updatedComponentInFormState } = updateJson;

  useEffect(() => {
    selectedControl.style.formConfig = {
      isFullPage: selectedControl?.style?.formConfig?.isFullPage,
      isFullPageConfig: {
        isAllPadding:
          selectedControl?.style?.formConfig?.isFullPageConfig?.isAllPadding ===
          true
            ? true
            : selectedControl?.style?.formConfig?.isFullPageConfig
                ?.isAllPadding === false
            ? false
            : true,
        isAllPaddingValue:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isAllPaddingValue || "0",
        isDifferentPadding:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isDifferentPadding || false,
        isDifferentPaddingValueTop:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isDifferentPaddingValueTop || "0",
        isDifferentPaddingValueRight:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isDifferentPaddingValueRight || "0",
        isDifferentPaddingValueBottom:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isDifferentPaddingValueBottom || "0",
        isDifferentPaddingValueLeft:
          selectedControl?.style?.formConfig?.isFullPageConfig
            ?.isDifferentPaddingValueLeft || "0",
      },
      isCustom: selectedControl?.style?.formConfig?.isCustom,
      isCustomConfig: {
        formHorizontalAlignment:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formHorizontalAlignment || "left",
        formHorizontalPadding:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formHorizontalAlignment || "0",
        formWidth:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formHorizontalAlignment || "100",
        formMinWidth:
          selectedControl?.style?.formConfig?.isCustomConfig?.formMinWidth ||
          "",
        formMaxWidth:
          selectedControl?.style?.formConfig?.isCustomConfig?.formMaxWidth ||
          "",
        formVerticalAlignment:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formVerticalAlignment || "top",
        formVerticalPadding:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formVerticalPadding || "0",
        formFitHeight:
          selectedControl?.style?.formConfig?.isCustomConfig?.formFitHeight ||
          false,
        formVerticalHeight:
          selectedControl?.style?.formConfig?.isCustomConfig
            ?.formVerticalHeight || "",
      },
    };
    selectedControl.style.customHeightAlignment =
      selectedControl?.style?.customHeightAlignment || "top";
    selectedControl.style.customWidthAlignment =
      selectedControl?.style?.customWidthAlignment || "start";
    selectedControl.style.formCustomMinWidth =
      selectedControl?.style?.formCustomMinWidth || "300";
  }, []);
  function getAllPages(forComponent) {
    axios
      .get(`/interfaces/${activeApplication.applicationId}`)
      .then((res) => {
        setAllPages([...res.data]);
      })
      .catch(() => {
        console.log(
          "ERROR ON LOADING PAGES OF APP ID ",
          activeApplication.applicationId
        );
      });
  }
  function handleZoneClose() {
    setOpenZoning(false);
  }
  function handleControlSetClose() {
    setOpenControlSet(false);
  }
  function handleTemplateClose() {
    setTemplateData({ ...templateData, isOpen: false });
  }
  function handleTemplateOpen() {
    setTemplateData({ ...templateData, isOpen: true });
  }

  function generatePageStyle() {
    let finalStyle = {};
    if (formState2.style?.["pageBackgroundType"] === "pageBackgroundColor") {
      finalStyle.backgroundColor =
        formData?.style?.["pageBackgroundColor"] || "#FFFFFF";
    }
    if (formState2.style?.["pageBackgroundType"] === "pageBackgroundImage") {
      finalStyle.backgroundImage = `url("${imageBaseURL}${
        `${formData?.style?.pageBackgroundImageFile}${loadArabicImage(imageBaseURL)}` || ""
      }")`;
      if (formState2?.style?.imageAppearanceType === "originalSize") {
        finalStyle.backgroundPositionX =
          formData?.style?.imageAppearanceAlignmentHorizontal || "center";
        finalStyle.backgroundPositionY =
          formData?.style?.imageAppearanceAlignmentVertical || "center";
      } else if (formState2?.style?.imageAppearanceType === "fitWidthwise") {
        finalStyle.backgroundSize = "100%";
        finalStyle.backgroundPositionY =
          formData?.style?.imageFitWidthWiseAlignment;
      } else if (formState2?.style?.imageAppearanceType === "fitHeightwise") {
        finalStyle.backgroundSize = "contain";
        finalStyle.backgroundPositionX =
          formData?.style?.imageFitHeightWiseAlignment;
      }
    }
    if (formState2?.style?.formConfig?.isFullPage) {
      if (formState2?.style?.formConfig?.isFullPageConfig?.isAllPadding) {
        finalStyle.padding = `${formState2?.style?.formConfig?.isFullPageConfig?.isAllPaddingValue}px`;
      }
      if (formState2?.style?.formConfig?.isFullPageConfig?.isDifferentPadding) {
        finalStyle.padding = `${formState2?.style?.formConfig?.isFullPageConfig?.isDifferentPaddingValueTop}px ${formState2?.style?.formConfig?.isFullPageConfig?.isDifferentPaddingValueRight}px ${formState2?.style?.formConfig?.isFullPageConfig?.isDifferentPaddingValueBottom}px ${formState2?.style?.formConfig?.isFullPageConfig?.isDifferentPaddingValueLeft}px`;
      }
      finalStyle.height = "100%";
    }
    if (formState2?.style?.isGradient) {
      if (
        formState2?.style?.backgroundGradientAngle &&
        formState2?.style?.gradientColor1 &&
        formState2?.style?.gradientColor1Angle &&
        formState2?.style?.gradientColor2 &&
        formState2?.style?.gradientColor2Angle &&
        formData?.style?.pageBackgroundImageFile
      ) {
        finalStyle.backgroundImage = `linear-gradient(${
          formState2?.style?.backgroundGradientAngle
        }deg,${formState2?.style?.gradientColor1 || "transparent"} ${
          formState2?.style?.gradientColor1Angle
        }%,${formState2?.style?.gradientColor2 || "transparent"} ${
          formState2?.style?.gradientColor2Angle
        }%),url("${imageBaseURL}${
          `${formData?.style?.pageBackgroundImageFile}${loadArabicImage(imageBaseURL)}` || ""
        }")`;
      } else {
        finalStyle.backgroundImage = `url("${imageBaseURL}${
          `${formData?.style?.pageBackgroundImageFile}${loadArabicImage(imageBaseURL)}` || ""
        }")`;
      }
    }
    return { ...finalStyle };
  }

  function handleProperty(property, value, isFormConfig, event) {
    var regex = /^\d*[.]?\d*$/;
    if (
      regex.test(value) ||
      property === "pageBackgroundColor" ||
      property === "formBackgroundColor" ||
      property === "formBorderColor" ||
      property === "gradientColor1" ||
      property === "gradientColor2"
    ) {
      if (isFormConfig) {
        if (
          property === "isAllPaddingValue" ||
          property === "isDifferentPaddingValueTop" ||
          property === "isDifferentPaddingValueRight" ||
          property === "isDifferentPaddingValueLeft" ||
          property === "isDifferentPaddingValueBottom"
        ) {
          if (parseInt(value) > 100) {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: `${t("Maximum limit of padding is 100")}`,
              autoHideDuration: 3000,
            });
          } else {
            formState2.style.formConfig.isFullPageConfig[property] = value;
          }
        }
      } else if (property === "formCustomMinWidth") {
        if (parseInt(value) < 300) {
          event.target.value = 300
          formState2.style[property] = 300
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t(
              "Form Minimum Width cannot be less than 300px"
            )}`,
            autoHideDuration: 3000,
          });
        } else {
          formState2.style[property] = value;
        }
      } else if (property === "formCustomHorizontalPadding") {
        let maxPading = Math.floor(
          (100 - parseInt(formState2?.style?.formCustomWidth)) / 2
        );
        if(!isNaN(maxPading)){
          if (parseInt(value) > maxPading) {
          event.target.value = maxPading
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t(
              "Horizontal Padding cannot be more than"
            )} ${maxPading}%`,
            autoHideDuration: 3000,
          });
          return;
        } else {
          formState2.style[property] = value;
        }
        } else {
          event.target.value = ""
        }
      } else if (property === "formCustomWidth") {
        if (parseInt(value) > 100) {
          event.target.value = 100
          formState2.style[property] = 100
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Form Width cannot be more than 100%")}`,
            autoHideDuration: 3000,
          });
        } else {
          formState2.style[property] = value;
        }
      } else if (property === "formCustomVerticalPadding") {
        let maxPading = Math.floor(
          (100 - parseInt(formState2?.style?.formCustomHeight)) / 2
        );
        if (value > maxPading) {
          event.target.value = maxPading
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t(
              "Vertical Padding cannot be more than"
            )} ${maxPading}%`,
            autoHideDuration: 3000,
          });
          return;
        } else {
          formState2.style[property] = value;
        }
      } else if (property === "formCustomHeight") {
        if (parseInt(value) > 100) {
          event.target.value = 100
          formState2.style[property] = 100
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Form Height cannot be more than 100%")}`,
            autoHideDuration: 3000,
          });
        } else {
          formState2.style[property] = value;
        }
      } else if (property === "formCustomMaxWidth"){
        if (parseInt(value) < parseInt(formState2.style["formCustomMinWidth"])) {
          event.target.value = parseInt(formState2.style["formCustomMinWidth"])
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t(
              `Form Maximum Width cannot be less than ${formState2.style["formCustomMinWidth"]}`
            )}`,
            autoHideDuration: 3000,
          }) 
        } else {
          formState2.style[property] = value;
        }
      } else {
        formState2.style[property] = value;
      }
      let finalStyles = generatePageStyle();
      setFormState2({ ...formState2, finalStyles: finalStyles });
    } else {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Please enter only numeric value")}`,
        autoHideDuration: 3000,
      });
    }
  }

  const updateEventData = (eventJson) => {
    var count = Object.keys(eventJson).length;
    let eventsInArray= {}
    if (count > 0) {
      var Events = {};
      Events["Events"] = eventJson;
      selectedControl["event"] = Events;
      for (let key in eventJson) {
        if (eventJson.hasOwnProperty(key)) {
            eventsInArray[key] = Object.keys(eventJson[key]).map(innerKey => ({ value: innerKey }));
        }
    }
    selectedControl["eventsInArray"] = eventsInArray
    
    }

    updatedComponentInFormState(selectedControl.id, selectedControl);
  };
  return (
    <div id="pagePropertiesNew" style={{ height: "100%" }}>
      {selectedControl ? (
        <>
          {selectedControl.elem_type === "Design Page" ||
          selectedControl.elem_type === "form" ? (
            <Card
              style={{ height: "100%" }}
              dir={
                window?.psh_configs?.selectedLanguage === "ar" ||
                window?.psh_configs?.selectedLanguage === "ar-SA"
                  ? "rtl"
                  : "ltr"
              }
              className={styles.propertiesBody1}
            >
              <HeaderSection
                t={t}
                setOpenZoning={setOpenZoning}
                setOpenControlSet={setOpenControlSet}
              />
              <div
                style={{
                  width: "100%",
                  overflowY: "auto",
                  paddingBottom: "20px",
                  minHeight: "500px"
                }}
                className={"propertiesBody"}
              >
                <CollapseCards heading={t("Basic Details")}>
                  <BasicDetailsComp
                    t={t}
                    formState2={formState2}
                    templateData={templateData}
                    handleTemplateOpen={handleTemplateOpen}
                  />
                </CollapseCards>
                <CollapseCards heading={t("Page Background")}>
                  <PageBackgroundComp
                    t={t}
                    selectedControl={selectedControl}
                    handleProperty={handleProperty}
                    containerId={containerId}
                    updatedComponentInFormState={updatedComponentInFormState}
                    formState2={formState2}
                    generatePageStyle={generatePageStyle}
                    setFormState2={setFormState2}
                  />
                </CollapseCards>
                <CollapseCards heading={t("Form Configuration")}>
                  <FormConfigurationComp
                    t={t}
                    formState2={formState2}
                    selectedControl={selectedControl}
                    handleProperty={handleProperty}
                    setFormState2={setFormState2}
                    updatedComponentInFormState={updatedComponentInFormState}
                    generatePageStyle={generatePageStyle}
                  />
                </CollapseCards>
                <CollapseCards heading={t("Form Background")}>
                  <FormBackgroundComp
                    t={t}
                    formState2={formState2}
                    selectedControl={selectedControl}
                    handleProperty={handleProperty}
                    setFormState2={setFormState2}
                  />
                </CollapseCards>
                <CollapseCards heading={t("Events")}>
                  <Events
                  control_json={selectedControl}
                    t={t}
                    key={selectedControl.id + "_eventsProperty"}
                    json={EventListjson}
                    value={selectedControl.event}
                    elemtype={selectedControl.elem_type}
                    updateEventData={(eventJson) => updateEventData(eventJson)}
                  ></Events>
                </CollapseCards>
              </div>
            </Card>
          ) : null}
        </>
      ) : null}
      {openZoning ? (
        <Zoning
          containerId={containerId}
          onClose={handleZoneClose}
          open={true}
        />
      ) : null}
      {openControlSet ? (
        <ControlSet
          containerId={containerId}
          onClose={handleControlSetClose}
          open={true}
        />
      ) : null}
      {templateData.isOpen ? (
        <SelectTemplate
          isTemplate={true}
          open={templateData.isOpen}
          handleClose={handleTemplateClose}
          setSelectedTemplateName={setTemplateData}
          getAllPages={() => getAllPages("page")}
          componentFor={"page"}
          pageProperties={pageProperties}
        />
      ) : null}
    </div>
  );
};

function FormBackgroundComp({ selectedControl, handleProperty, t }) {
  return (
    <div id="formBackgroundContainer">
      <div
        id="formBgColor"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div id="formBgLeft">
          <span>{t("Background Color")}</span>
        </div>
        <div id="formBgRight">
          <ColorPicker
            color={
              selectedControl && selectedControl.style
                ? selectedControl.style["formBackgroundColor"]
                : "#FFFFFF"
            }
            handleProperty={handleProperty}
            propertyName={"formBackgroundColor"}
          />
        </div>
      </div>
      <div
        id="formBorder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div id="formBorderLeft">
          <span>{t("Border Color")}</span>
        </div>
        <div id="formBgRight">
          <ColorPicker
            color={
              selectedControl && selectedControl.style
                ? selectedControl.style["formBorderColor"]
                : "#FFFFFF"
            }
            handleProperty={handleProperty}
            propertyName={"formBorderColor"}
          />
        </div>
      </div>
    </div>
  );
}

function FormConfigurationComp({
  selectedControl,
  handleProperty,
  formState2,
  setFormState2,
  t,
  generatePageStyle,
}) {
  const classes = useStyles();
  const [isFullPageType, setIsFullPageType] = useState(
    selectedControl?.style?.formConfig?.isFullPageConfig?.isAllPadding
      ? "allPadding"
      : "allDifferent"
  );
  const [formConfigType, setFormConfigType] = useState(
    selectedControl.style.formConfig.isFullPage
      ? "isFullPage"
      : selectedControl.style.formConfig.isCustom
      ? "isCustom"
      : ""
  );
  function updateState() {
    let finalStyles = generatePageStyle();
    setFormState2({ ...formState2, finalStyles: finalStyles });
  }
  function handleFormConfigType(value) {
    setFormConfigType(value);
    if (value === "isFullPage") {
      formState2.style.formConfig.isCustom = false;
      formState2.style.formConfig.isFullPage = true;
      formState2.style.isFitHeight = false;
    } else {
      formState2.style.formConfig.isFullPage = false;
      formState2.style.formConfig.isCustom = true;
    }
    updateState();
  }
  function handlePaddingType(value) {
    setIsFullPageType(value);
    if (value === "allPadding") {
      formState2.style.formConfig.isFullPageConfig.isDifferentPadding = false;
      formState2.style.formConfig.isFullPageConfig.isAllPadding = true;
    } else {
      formState2.style.formConfig.isFullPageConfig.isDifferentPadding = true;
      formState2.style.formConfig.isFullPageConfig.isAllPadding = false;
    }
    updateState();
  }

  function handleFormWidthAlignment(isHeight, value) {
    if (isHeight) {
      formState2.style.customHeightAlignment = value;
    } else {
      formState2.style.customWidthAlignment = value;
    }
    updateState();
  }
  function handleFitHeightToggle(value) {
    selectedControl.style.isFitHeight = selectedControl?.style?.isFitHeight
      ? !selectedControl?.style?.isFitHeight
      : true;
    updateState();
  }
  return (
    <>
      <RadioGroup
        defaultValue={formConfigType}
        aria-label="Form Configuration"
        name="formConfig"
        onChange={(event) => handleFormConfigType(event.target.value)}
      >
        <div style={{ marginLeft: "5px" }}>
          <FormControlLabel
            style={{ fontFamily: "Open Sans" }}
            value="isFullPage"
            control={<StyledRadio />}
            label={<span style={{ fontSize: "11px" }}>{t("Full Page")}</span>}
            name="formConfig"
          />
          {selectedControl.style.formConfig.isFullPage === true ? (
            <>
              <div
                id="paddingDiv"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                }}
              >
                <span>{t("Padding")}</span>
                <div>
                  {formConfigType === "isFullPage" ? (
                    <div
                      style={{
                        width: "46px",
                        border: "1px solid #C4C4C4",
                        borderRadius: "2px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 3px",
                        marginLeft: "10px",
                      }}
                    >
                      <img
                        height={14}
                        src={
                          isFullPageType === "allPadding"
                            ? AllPaddingActive
                            : AllPaddingInActive
                        }
                        alt="All Padding"
                        onClick={() => handlePaddingType("allPadding")}
                      />
                      <span style={{ margin: "0px 2px", color: "#C4C4C4" }}>
                        |
                      </span>
                      <img
                        height={14}
                        src={
                          isFullPageType === "allDifferent"
                            ? DifferentPaddingActive
                            : DifferentPaddingInActive
                        }
                        alt="Different Padding"
                        onClick={() => handlePaddingType("allDifferent")}
                      />
                      <span style={{ margin: "0px 2px", color: "#C4C4C4" }}>
                        -
                      </span>
                      {isFullPageType === "allPadding" ? (
                        <div
                          id="allPaddingInput"
                          style={{ marginLeft: "20px" }}
                        >
                          <input
                            aria-label="All Padding Value"
                            key={"isAllPaddingValue"}
                            type="text"
                            style={{
                              width: "35px",
                              height: "24px",
                              textAlign: "center",
                            }}
                            defaultValue={
                              selectedControl?.style?.formConfig
                                ?.isFullPageConfig?.isAllPaddingValue
                            }
                            onBlur={(event) =>
                              handleProperty(
                                "isAllPaddingValue",
                                event.target.value,
                                true
                              )
                            }
                          />
                        </div>
                      ) : (
                        <div
                          id="differentPaddingInput"
                          className={
                            pagePropertiesStyles.differentPaddingContainer
                          }
                        >
                          <input
                            aria-label="Is Diffrent Value Top"
                            key={"isDifferentPaddingValueTop"}
                            type="text"
                            className={pagePropertiesStyles.inputBoxStyle}
                            defaultValue={
                              selectedControl?.style?.formConfig
                                ?.isFullPageConfig?.isDifferentPaddingValueTop
                            }
                            onBlur={(event) =>
                              handleProperty(
                                "isDifferentPaddingValueTop",
                                event.target.value,
                                true
                              )
                            }
                          />
                          <input
                            aria-label="Is Diffrent Value Right"
                            type="text"
                            key={"isDifferentPaddingValueRight"}
                            className={pagePropertiesStyles.inputBoxStyle}
                            defaultValue={
                              selectedControl?.style?.formConfig
                                ?.isFullPageConfig?.isDifferentPaddingValueRight
                            }
                            onBlur={(event) =>
                              handleProperty(
                                "isDifferentPaddingValueRight",
                                event.target.value,
                                true
                              )
                            }
                          />
                          <input
                            aria-label="Is Diffrent Value Bottom"
                            type="text"
                            key={"isDifferentPaddingValueBottom"}
                            className={pagePropertiesStyles.inputBoxStyle}
                            defaultValue={
                              selectedControl?.style?.formConfig
                                ?.isFullPageConfig
                                ?.isDifferentPaddingValueBottom
                            }
                            onBlur={(event) =>
                              handleProperty(
                                "isDifferentPaddingValueBottom",
                                event.target.value,
                                true
                              )
                            }
                          />
                          <input
                            aria-label="Is Diffrent Value Left"
                            type="text"
                            key={"isDifferentPaddingValueLeft"}
                            className={pagePropertiesStyles.inputBoxStyle}
                            defaultValue={
                              selectedControl?.style?.formConfig
                                ?.isFullPageConfig?.isDifferentPaddingValueLeft
                            }
                            onBlur={(event) =>
                              handleProperty(
                                "isDifferentPaddingValueLeft",
                                event.target.value,
                                true
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div style={{ marginLeft: "5px" }}>
          <FormControlLabel
            style={{ fontFamily: "Open Sans" }}
            aria-label="Custom Width and height"
            value="isCustom"
            control={<StyledRadio />}
            label={
              <span style={{ fontSize: "11px" }}>
                {t("Custom width and height")}
              </span>
            }
            name="formConfig"
          />
          {formState2?.style?.formConfig?.isCustom === true ? (
            <div id="customWidth">
              <div id="SetFormWidthContainer" style={{ marginTop: "3px" }}>
                <span style={{ fontWeight: "bold" }}>
                  {t("Set Form Width")}
                </span>
                <div
                  id="horizontalOptionDiv"
                  style={{
                    width: "90px",
                    border: "1px solid #C4C4C4",
                    display: "flex",
                    height: "30px",
                    overflow: "hidden",
                  }}
                >
                   <Tooltip title={t("Align left")} 
                    placement={"bottom-start"}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    arrow>
                  <div
                    tabIndex={0}
                    style={{
                      flex: 1,
                      borderRight: "1px solid #C4C4C4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor:
                        selectedControl.style.customWidthAlignment === "start"
                          ? "#0072C6"
                          : "",
                    }}
                    className={classes.hoverBtnColor}
                    onClick={() => handleFormWidthAlignment(false, "start")}
                  >
                    <LeftAlignSvg
                      selected={
                        selectedControl.style.customWidthAlignment === "start"
                      }
                    />
                  </div>
                  </Tooltip>
                  <Tooltip title={t("Align horizontal center")} 
                    placement={"bottom-start"}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    arrow>
                  <div
                    tabIndex={0}
                    style={{
                      flex: 1,
                      borderRight: "1px solid #C4C4C4",
                      borderTop: "1px solid #C4C4C4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      transform: "rotate(90deg)",
                      height: "30px",
                      backgroundColor:
                        selectedControl.style.customWidthAlignment === "center"
                          ? "#0072C6"
                          : "",
                    }}
                    className={classes.hoverBtnColor}
                    onClick={() => handleFormWidthAlignment(false, "center")}
                  >
                    <CenterAlign
                      selected={
                        selectedControl.style.customWidthAlignment === "center"
                      }
                    />
                  </div>
                  </Tooltip>
                  <Tooltip title={t("Align right")} 
                    placement={"bottom-start"}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    arrow>
                  <div
                    tabIndex={0}
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor:
                        selectedControl.style.customWidthAlignment === "end"
                          ? "#0072C6"
                          : "",
                    }}
                    className={classes.hoverBtnColor}
                    onClick={() => handleFormWidthAlignment(false, "end")}
                  >
                    <RIghtAlign
                      selected={
                        selectedControl.style.customWidthAlignment === "end"
                      }
                    />
                  </div>
                  </Tooltip>
                </div>
                <div
                  id="customWidthProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Form Width")}</span>
                  </div>
                  <div id="customWidthRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                    >
                      <input
                        tabIndex={0}
                        aria-label="Form Custom Width"
                        key={"formCustomWidth"}
                        type="text"
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        defaultValue={selectedControl?.style?.formCustomWidth}
                        onBlur={(event) =>
                          handleProperty("formCustomWidth", event.target.value, "", event)
                        }
                      />
                      <span style={{ marginRight: "3px" }}>%</span>
                    </div>
                  </div>
                </div>
                <div
                  id="customMinWidthProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Min.Form Width")}</span>
                    <Tooltip
                      title={
                        "The minimum width should not be less that 300 Px."
                      }
                      placement={"bottom-start"}
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.arrow,
                      }}
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        style={{ marginLeft: "3px" }}
                      />
                    </Tooltip>
                  </div>
                  <div id="customWidthRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                    >
                      <input
                        tabIndex={0}
                        aria-label="Form Custom Width"
                        key={"formCustomMinWidth"}
                        type="text"
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        defaultValue={
                          selectedControl?.style?.formCustomMinWidth || "300"
                        }
                        onBlur={(event) =>
                          handleProperty(
                            "formCustomMinWidth",
                            event.target.value,
                            "",
                            event
                          )
                        }
                      />
                      <span style={{ marginRight: "3px" }}>Px</span>
                    </div>
                  </div>
                </div>
                <div
                  id="customMaxWidthProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Max Form Width (Optional)")}</span>
                  </div>
                  <div id="customWidthRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                    >
                      <input
                        tabIndex={0}
                        aria-label="Form Custom Max Width"
                        key={"formCustomMaxWidth"}
                        type="text"
                        disabled={!formState2?.style?.formCustomMinWidth}
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        defaultValue={
                          selectedControl?.style?.formCustomMaxWidth
                        }
                        onBlur={(event) =>
                          handleProperty(
                            "formCustomMaxWidth",
                            event.target.value,
                            "",
                            event
                          )
                        }
                      />
                      <span style={{ marginRight: "3px" }}>Px</span>
                    </div>
                  </div>
                </div>
                <div
                  id="customHorizontalPaddinghProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Horizontal Padding")}</span>
                  </div>
                  <div id="customWidthRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                      style={
                        formState2?.style?.customWidthAlignment === "center"
                          ? { backgroundColor: "rgba(196, 196, 196, 0.80)" }
                          : null
                      }
                    >
                      <input
                        tabIndex={0}
                        aria-label="Custom Horizontal Padding"
                        key={"formCustomHorizontalPadding"}
                        disabled={
                          !formState2?.style?.formCustomWidth ||
                          formState2?.style?.customWidthAlignment === "center"
                        }
                        type="text"
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        style={
                          formState2?.style?.customWidthAlignment === "center"
                            ? { backgroundColor: "rgba(196, 196, 196, 0.80)" }
                            : null
                        }
                        defaultValue={
                          selectedControl?.style?.formCustomHorizontalPadding
                        }
                        onBlur={(event) =>
                          handleProperty(
                            "formCustomHorizontalPadding",
                            event.target.value,
                            "",
                            event
                          )
                        }
                      />
                      <span style={{ marginRight: "3px" }}>%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div id="SetFormHeightContainer" style={{ marginTop: "3px" }}>
                <span style={{ fontWeight: "bold" }}>
                  {t("Set Form Height")}
                </span>
                <div
                  id="verticalOptionDiv"
                  style={{
                    width: "90px",
                    border: "1px solid #C4C4C4",
                    height: "30px",
                    display: "flex",
                  }}
                >
                   <Tooltip title={t("Align top")} 
                    placement={"bottom-start"}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    arrow>
                  <div
                    tabIndex={0}
                    style={{
                      flex: 1,
                      borderRight: "1px solid #C4C4C4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor:
                        selectedControl.style.customHeightAlignment === "top"
                          ? "#0072C6"
                          : "",
                    }}
                    className={classes.hoverBtnColor}
                    onClick={() => handleFormWidthAlignment(true, "top")}
                  >
                    <TopAlign
                      selected={
                        selectedControl.style.customHeightAlignment === "top"
                      }
                    />
                  </div>
                  </Tooltip>
                  <Tooltip title={t("Align vertical center")} 
                    placement={"bottom-start"}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    arrow>
                  <div
                    tabIndex={0}
                    style={{
                      flex: 1,
                      borderRight: "1px solid #C4C4C4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor:
                        selectedControl.style.customHeightAlignment === "center"
                          ? "#0072C6"
                          : "",
                    }}
                    className={classes.hoverBtnColor}
                    onClick={() => handleFormWidthAlignment(true, "center")}
                  >
                    <CenterVertAlign
                      selected={
                        selectedControl.style.customHeightAlignment === "center"
                      }
                    />
                  </div>
                  </Tooltip>
                </div>
                <span style={{ display: "flex", marginTop: "10px" }}>
                  <input
                    tabIndex={0}
                    aria-label="Fit Height Toggle"
                    type="checkbox"
                    defaultChecked={
                      selectedControl?.style?.isFitHeight ? true : false
                    }
                    onChange={handleFitHeightToggle}
                    style={{ width: "12px" }}
                  />{" "}
                  {t("Fit the height to its content")}
                </span>
                <div
                  id="customHeightProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Form Height")}</span>
                  </div>
                  <div id="customHeightRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                    >
                      <input
                        tabIndex={0}
                        aria-label="Custom Height"
                        key={"formCustomHeight"}
                        type="text"
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        style={
                          selectedControl?.style?.isFitHeight
                            ? { backgroundColor: "rgba(196, 196, 196, 0.80)" }
                            : null
                        }
                        disabled={selectedControl?.style?.isFitHeight}
                        defaultValue={selectedControl?.style?.formCustomHeight}
                        onBlur={(event) =>
                          handleProperty("formCustomHeight", event.target.value, "", event)
                        }
                      />
                      <span style={{ marginRight: "3px" }}>%</span>
                    </div>
                  </div>
                </div>
                <div
                  id="customVerticalPaddinghProperties"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div id="customWidthLeftContainer">
                    <span>{t("Vertical Padding")}</span>
                  </div>
                  <div id="customWidthRightContainer">
                    <div
                      className={pagePropertiesStyles.customPropertyContainer}
                      style={
                        formState2?.style?.customHeightAlignment === "center"
                          ? { backgroundColor: "rgba(196, 196, 196, 0.80)" }
                          : null
                      }
                    >
                      <input
                        tabIndex={0}
                        aria-label="Vertical Padding"
                        key={"formCustomVerticalPadding"}
                        disabled={
                          formState2?.style?.customHeightAlignment === "center"
                        }
                        type="text"
                        className={
                          pagePropertiesStyles.gradientInputBoxStyleForm
                        }
                        style={
                          formState2?.style?.customHeightAlignment === "center"
                            ? { backgroundColor: "rgba(196, 196, 196, 0.80)" }
                            : null
                        }
                        defaultValue={
                          selectedControl?.style?.formCustomVerticalPadding
                        }
                        onBlur={(event) =>
                          handleProperty(
                            "formCustomVerticalPadding",
                            event.target.value,
                            "",
                            event
                          )
                        }
                      />
                      <span style={{ marginRight: "3px" }}>%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </RadioGroup>
    </>
  );
}

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      aria-label="Radio Button"
      inputProps={{ "aria-label": "Radio Button" }}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

function PageBackgroundComp({
  selectedControl,
  handleProperty,
  containerId,
  formState2,
  t,
  generatePageStyle,
  setFormState2,
}) {
  const [bgType, setBgType] = useState(
    selectedControl.style["pageBackgroundType"]
  );
  function updateState() {
    let finalStyles = generatePageStyle();
    setFormState2({ ...formState2, finalStyles: finalStyles });
  }
  function handleBgType(value) {
    setBgType(value);
    // if (value === "pageBackgroundColor") {
    //   formState2.style["pageBackgroundImageName"] = "";
    //   formState2.style["pageBackgroundImageFile"] = "";
    // } else {
    //   formState2.style["pageBackgroundColor"] = "";
    // }
    formState2.style["pageBackgroundType"] = value;
    updateState();
  }
  function handleImageUpload(imageName, imageFile) {
    formState2.style["pageBackgroundImageName"] = imageName;
    formState2.style["pageBackgroundImageFile"] = imageFile;
    updateState();
  }
  function handleImageAppearanceType(value) {
    formState2.style.imageAppearanceType = value;
    updateState();
  }
  function handleImageAlignment(vertical, value) {
    if (vertical) {
      formState2.style.imageAppearanceAlignmentVertical = value;
    } else {
      formState2.style.imageAppearanceAlignmentHorizontal = value;
    }
    updateState();
  }

  function handleFitWidthWise(value) {
    selectedControl.style.imageFitWidthWiseAlignment = value;
    updateState();
  }
  function handleFitHeightWise(value) {
    selectedControl.style.imageFitHeightWiseAlignment = value;
    updateState();
  }

  function handleGradientToggle(value) {
    selectedControl.style.isGradient = selectedControl?.style?.isGradient
      ? !selectedControl?.style?.isGradient
      : true;
    updateState();
  }
  const gradientAngleList = [
    30, 45, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360,
  ];

  const classes = useStyles();

  return (
    <>
      <div id="pageBackground" style={{ marginLeft: "5px" }}>
        <RadioGroup
          defaultValue={selectedControl.style["pageBackgroundType"] || bgType}
          aria-label="Page Background"
          name="bgType"
          onChange={(event) => handleBgType(event.target.value)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              tabIndex={0}
              style={{ fontFamily: "Open Sans" }}
              value="pageBackgroundColor"
              control={<StyledRadio />}
              label={
                <span style={{ fontSize: "11px" }}>{t("Page Background")}</span>
              }
              name="bgType"
            />
            {bgType === "pageBackgroundColor" ? (
              <ColorPicker
                color={
                  selectedControl && selectedControl?.style
                    ? selectedControl.style["pageBackgroundColor"]
                    : "#FFFFFF"
                }
                handleProperty={handleProperty}
                propertyName={"pageBackgroundColor"}
              />
            ) : null}
          </div>
          <FormControlLabel
            tabIndex={0}
            style={{ fontFamily: "Open Sans" }}
            value="pageBackgroundImage"
            control={<StyledRadio />}
            label={
              <span style={{ fontSize: "11px" }}>{t("Background Image")}</span>
            }
            name="bgType"
          />
          {bgType === "pageBackgroundImage" ? (
            <div style={{ width: "100%" }}>
              <ImageUploadBtn
                handleImageUpload={handleImageUpload}
                containerId={containerId}
                iconName={selectedControl?.style?.pageBackgroundImageName}
              />
              <span>{t("RecommendRes")}</span>
              <br />
              <div id="imageApperanceContainer" style={{ marginTop: "10px" }}>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  {t("Image Appearance")}
                </span>
              </div>

              <RadioGroup
                defaultValue={selectedControl?.style?.imageAppearanceType || ""}
                aria-label="Image Appearance"
                name="imageAppearanceType"
                onChange={(event) =>
                  handleImageAppearanceType(event.target.value)
                }
                style={{ marginLeft: "10px", marginTop: "10px" }}
              >
                <FormControlLabel
                  value="originalSize"
                  control={<StyledRadio />}
                  label={
                    <span style={{ fontSize: "11px" }}>
                      {t("Original Size")}
                    </span>
                  }
                  name="imageAppearanceType"
                />
                {selectedControl?.style?.imageAppearanceType ===
                "originalSize" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      id="horizontalOptionDiv"
                      style={{
                        width: "90px",
                        border: "1px solid #C4C4C4",
                        display: "flex",
                        height: "30px",
                      }}
                    >
                      <Tooltip title={t("Align Left")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "left"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(false, "left")}
                      >
                        <LeftAlignSvg
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "left"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align horizontal center")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "center"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(false, "center")}
                      >
                        <CenterAlign
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "center"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align Right")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "right"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(false, "right")}
                      >
                        <RIghtAlign
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentHorizontal === "right"
                          }
                        />
                      </div>
                      </Tooltip>
                    </div>
                    <div
                      id="verticalOptionDiv"
                      style={{
                        width: "90px",
                        border: "1px solid #C4C4C4",
                        height: "30px",
                        display: "flex",
                      }}
                    >
                      <Tooltip title={t("Align top")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "top"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(true, "top")}
                      >
                        <TopAlign
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "top"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align vertical center")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "center"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(true, "center")}
                      >
                        <CenterVertAlign
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "center"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align bottom")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "bottom"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleImageAlignment(true, "bottom")}
                      >
                        <BottonAlign
                          selected={
                            selectedControl.style
                              .imageAppearanceAlignmentVertical === "bottom"
                          }
                        />
                      </div>
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
                <FormControlLabel
                  value="fitWidthwise"
                  control={<StyledRadio />}
                  label={
                    <span style={{ fontSize: "11px" }}>
                      {t("Fit Width-wise")}
                    </span>
                  }
                  name="imageAppearanceType"
                />
                {selectedControl?.style?.imageAppearanceType ===
                "fitWidthwise" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      id="fitWidthwiseVerticalOptionDiv"
                      style={{
                        width: "90px",
                        border: "1px solid #C4C4C4",
                        height: "30px",
                        display: "flex",
                      }}
                    >
                      <Tooltip title={t("Align top")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "top"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitWidthWise("top")}
                      >
                        <TopAlign
                          selected={
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "top"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align vertical center")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "center"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitWidthWise("center")}
                      >
                        <CenterVertAlign
                          selected={
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "center"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align bottom")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "bottom"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitWidthWise("bottom")}
                      >
                        <BottonAlign
                          selected={
                            selectedControl.style.imageFitWidthWiseAlignment ===
                            "bottom"
                          }
                        />
                      </div>
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
                <FormControlLabel
                  value="fitHeightwise"
                  control={<StyledRadio />}
                  label={
                    <span style={{ fontSize: "11px" }}>
                      {t("Fit Height-wise")}
                    </span>
                  }
                  name="imageAppearanceType"
                />
                {selectedControl?.style?.imageAppearanceType ===
                "fitHeightwise" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      marginLeft: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      id="horizontalOptionDiv"
                      style={{
                        width: "90px",
                        border: "1px solid #C4C4C4",
                        display: "flex",
                        height: "30px",
                      }}
                    >
                      <Tooltip title={t("Align left")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "left"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitHeightWise("left")}
                      >
                        <LeftAlignSvg
                          selected={
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "left"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align horizontal center")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          borderRight: "1px solid #C4C4C4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "center"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitHeightWise("center")}
                      >
                        <CenterAlign
                          selected={
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "center"
                          }
                        />
                      </div>
                      </Tooltip>
                      <Tooltip title={t("Align right")} 
                        placement={"bottom-start"}
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        arrow>
                      <div
                        tabIndex={0}
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "right"
                              ? "#0072C6"
                              : "",
                        }}
                        className={classes.hoverBtnColor}
                        onClick={() => handleFitHeightWise("right")}
                      >
                        <RIghtAlign
                          selected={
                            selectedControl.style
                              .imageFitHeightWiseAlignment === "right"
                          }
                        />
                      </div>
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
              </RadioGroup>

              <Divider flexItem />

              <span style={{ display: "flex" }}>
                <input
                  tabIndex={0}
                  aria-label="Gradient Enable"
                  type="checkbox"
                  defaultChecked={selectedControl?.style?.isGradient}
                  value={selectedControl?.style?.isGradient}
                  disabled={!selectedControl.style.pageBackgroundImageFile}
                  onChange={handleGradientToggle}
                  style={{ width: "12px" }}
                />{" "}
                {t("Gradient as Overlay to Image")}
              </span>

              {selectedControl?.style?.isGradient ? (
                <div id="gradientContainer" style={{ marginTop: "10px" }}>
                  <div
                    id="color1"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div id="color1Left">
                      <span>{t("Color 1")}</span>
                    </div>
                    <div
                      id="color1Right"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <ColorPicker
                        color={
                          selectedControl && selectedControl.style
                            ? selectedControl.style["gradientColor1"]
                            : "transparent"
                        }
                        handleProperty={handleProperty}
                        propertyName={"gradientColor1"}
                      />
                      <div
                        style={{
                          display: "flex",
                          position: "relative",
                          border: "1px solid #C4C4C4",
                          alignItems: "center",
                        }}
                      >
                        <input
                          tabIndex={0}
                          aria-label="Gradient Color 1"
                          key={"gradientColor1"}
                          type="text"
                          className={pagePropertiesStyles.gradientInputBoxStyle}
                          defaultValue={
                            selectedControl?.style?.gradientColor1Angle
                          }
                          onInput={(event) => {
                            const value = parseInt(event.target.value, 10);

                            if (!isNaN(value)) {
                              if (value > 100) {
                                let trimmed = event.target.value;
                                while (parseInt(trimmed, 10) > 100 && trimmed.length > 0) {
                                  trimmed = trimmed.slice(0, -1);
                                }
                                event.target.value = trimmed;
                              }
                            } else {
                              event.target.value = '';
                            }
                          }}
                          onBlur={(event) =>
                            handleProperty(
                              "gradientColor1Angle",
                              event.target.value
                            )
                          }
                        />
                        <span style={{ marginRight: "3px" }}>%</span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="color2"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "2px",
                    }}
                  >
                    <div id="color2Left">
                      <span>{t("Color 2")}</span>
                    </div>
                    <div
                      id="color1Right"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <ColorPicker
                        color={
                          selectedControl && selectedControl.style
                            ? selectedControl.style["gradientColor2"]
                            : "transparent"
                        }
                        handleProperty={handleProperty}
                        propertyName={"gradientColor2"}
                      />
                      <div
                        style={{
                          display: "flex",
                          position: "relative",
                          border: "1px solid #C4C4C4",
                          alignItems: "center",
                          borderRadius: "2px",
                        }}
                      >
                        <input
                          tabIndex={0}
                          aria-label="Gradient Color 2"
                          key={"gradientColor2"}
                          type="text"
                          className={pagePropertiesStyles.gradientInputBoxStyle}
                          defaultValue={
                            selectedControl?.style?.gradientColor2Angle
                          }
                            onInput={(event) => {
                            const value = parseInt(event.target.value, 10);

                            if (!isNaN(value)) {
                              if (value > 100) {
                                let trimmed = event.target.value;
                                while (parseInt(trimmed, 10) > 100 && trimmed.length > 0) {
                                  trimmed = trimmed.slice(0, -1);
                                }
                                event.target.value = trimmed;
                              }
                            } else {
                              event.target.value = '';
                            }
                          }}
                          onBlur={(event) =>
                            handleProperty(
                              "gradientColor2Angle",
                              event.target.value
                            )
                          }
                        />
                        <span style={{ marginRight: "3px" }}>%</span>
                      </div>
                    </div>
                  </div>
                  <div
                    id="gradientDirection"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "3px",
                    }}
                  >
                    <div id="gradientAngle">
                      <span>{t("Gradient Angle")}</span>
                    </div>
                    <div
                      id="color1Right"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <select
                        aria-label="Gradient Angle"
                        key={"gradientAngle"}
                        onChange={(event) =>
                          handleProperty(
                            "backgroundGradientAngle",
                            event.target.value
                          )
                        }
                        className={pagePropertiesStyles.comboGradientAngle}
                      >
                        <option value="0">{t("Select")}</option>
                        {gradientAngleList.map((item) => (
                          <option
                            value={item}
                            selected={
                              selectedControl?.style
                                ?.backgroundGradientAngle === `${item}`
                            }
                          >
                            {item} {t("Degree")}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </RadioGroup>
        {}
      </div>
    </>
  );
}

function BasicDetailsComp({ formState2, templateData, handleTemplateOpen, t }) {
  return (
    <>
      <div id="basicDetails">
        <div className={pagePropertiesStyles.collapseItems}>
          <span style={{ fontSize: "10.5px" }}>{t("Page Template")}</span>
          <div
            tabIndex={0}
            style={{
              width: "176px",
              height: "28px",
              display: "flex",
              border: "1px #C4C4C4 solid",
              borderRadius: "2px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className={pagePropertiesStyles.selectTemplateContainer}
            onClick={() => handleTemplateOpen()}
          >
            <span
              style={{
                marginLeft: "3px",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {formState2?.style?.selectedTemplateName
                ? formState2?.style?.selectedTemplateName
                : t("Select Template")}
            </span>
            <img
              src={MoreVert}
              alt="More option"
              style={{
                height: "100%",
                padding: "5px",
                borderLeft: "1px #C4C4C4 solid",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function HeaderSection({ setOpenZoning, setOpenControlSet, t }) {
  return (
    <>
      <div
        id="headerContainer"
        className={pagePropertiesStyles.headerContainer}
      >
        <div
          id="headerLeft"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px 0px 0px 0px",
            marginLeft: "10px",
          }}
        >
          <h1 style={{ fontSize: "14px", fontWeight: "bold" }}>
            {t("Page & Form")}
          </h1>
        </div>
        <div id="headerRight" style={{ height: "auto", display: "flex" }}>
          <button
            tabIndex={0}
            className={pagePropertiesStyles.pagePropButton}
            onClick={() => setOpenZoning(true)}
          >
            {t("Zones")}
          </button>
          <button
            tabIndex={0}
            className={pagePropertiesStyles.pagePropButton}
            onClick={() => setOpenControlSet(true)}
          >
            {t("Control Sets")}
          </button>
        </div>
      </div>
    </>
  );
}
